(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/download-order.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/download-order.js');
"use strict";


const {
  useState,
  useEffect,
  useCallback
} = React;
const Button = svs.ui.ReactButton;
const {
  DOWNLOAD_BUTTON_LABEL,
  SEND_AGAIN_LABEL,
  SEND_AGAIN_SUCCESS_MESSAGE,
  SEND_AGAIN_SUCCESS_TITLE,
  SEND_AGAIN_MISSING_PHONE
} = svs.ticket_partner.myOrders.constants.TEXTS.DOWNLOAD_ORDER;
const useDownloadTextHook = (numberOfDownloads, lastDownload) => {
  const getDateAndTime = useCallback(lastDownload => "".concat(svs.utils.date.SimpleDate(new Date(lastDownload)), " ").concat(svs.utils.date.SimpleTime(new Date(lastDownload))), []);
  const [tempNumberOfDownloads, setTempNumberOfDownloads] = useState(numberOfDownloads);
  const [tempDownloadedDate, setTempDownloadedDate] = useState(getDateAndTime(lastDownload));
  const generateDownloadText = useCallback((numberOfDownloads, lastDownload) => "".concat(numberOfDownloads, " ").concat(numberOfDownloads > 1 ? 'gånger' : 'gång', " (senast ").concat(getDateAndTime(lastDownload), ")"), [getDateAndTime]);
  const [downloadText, setDownloadText] = useState(generateDownloadText(tempNumberOfDownloads, tempDownloadedDate));
  useEffect(() => {
    setDownloadText(generateDownloadText(tempNumberOfDownloads, tempDownloadedDate));
  }, [tempNumberOfDownloads, tempDownloadedDate, generateDownloadText]);
  const setDownloadData = useCallback((numberOfDownloads, downloadDate) => {
    setTempNumberOfDownloads(numberOfDownloads);
    setTempDownloadedDate(getDateAndTime(downloadDate));
  }, [getDateAndTime]);
  return {
    downloadText,
    setDownloadData,
    tempNumberOfDownloads
  };
};
const DownloadOrder = _ref => {
  let {
    numberOfDownloads,
    lastDownload,
    orderId
  } = _ref;
  const {
    downloadText,
    tempNumberOfDownloads,
    setDownloadData
  } = useDownloadTextHook(numberOfDownloads, lastDownload);
  const onDownload = async (e, orderId) => {
    e === null || e === void 0 || e.preventDefault();
    svs.ui.loader.show();
    try {
      const {
        response
      } = await svs.ticket_partner.services.downloadOrder(orderId);
      svs.ticket_partner.services.downloadZip(response, orderId);
      setDownloadData(tempNumberOfDownloads + 1, Date.now());
    } catch (e) {
      svs.ticket_partner.logger.error('Failed to get zip');
      svs.ticket_partner.utils.showErrorDialog();
    }
    svs.ui.loader.hide();
  };
  const onSendAgain = async (e, orderId) => {
    e === null || e === void 0 || e.preventDefault();
    svs.ui.loader.show();
    try {
      var _data$response$msg;
      const data = await svs.ticket_partner.services.sendPassword(orderId);
      if (((_data$response$msg = data.response.msg) === null || _data$response$msg === void 0 ? void 0 : _data$response$msg.toLowerCase().indexOf('phone missing')) >= 0) {
        svs.ticket_partner.utils.showErrorDialog(SEND_AGAIN_MISSING_PHONE);
      } else {
        svs.ticket_partner.utils.showSuccessDialog(SEND_AGAIN_SUCCESS_MESSAGE, SEND_AGAIN_SUCCESS_TITLE);
      }
    } catch (e) {
      svs.ticket_partner.logger.error('Failed to send password', e);
      svs.ticket_partner.utils.showErrorDialog();
    }
    svs.ui.loader.hide();
  };
  return React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement("div", null, React.createElement("p", null, "Har du inte f\xE5tt dina best\xE4llda digitala lotter eller tappat bort koderna? Du kan h\xE4mta en lista \xF6ver koderna igen."), React.createElement("b", null, "H\xE4mtad: \xA0"), React.createElement("span", null, downloadText)), React.createElement("div", null, React.createElement("b", null, "Dekrypteringsnyckel: \xA0"), React.createElement("span", null, "Har skickats via SMS. "), React.createElement("a", {
    href: "",
    onClick: e => onSendAgain(e, orderId)
  }, SEND_AGAIN_LABEL), React.createElement("div", {
    className: "margin-top-1 margin-bottom-1"
  }, React.createElement(Button, {
    inverted: true,
    onClick: e => onDownload(e, orderId)
  }, DOWNLOAD_BUTTON_LABEL))));
};
svs.ticket_partner.myOrders.components.DownloadOrder = DownloadOrder;

 })(window);